<template>
  <div :class="boardClasses">
    <div class="mask" @click="close" />
    <div class="board" :style="boardStyle">
      <div class="board-header">
        <span>请您稍后</span>
        <div class="board-header-close" @click="close" />
      </div>
      <div class="board-content">
        <div class="board-item message">
          <textarea v-model="content" rows="3" placeholder="请在此输入留言内容，我们会尽快和您联系" />
        </div>
        <div class="board-item">
          <input v-model="config.name" placeholder="请输入姓名" />
        </div>
        <div class="board-item">
          <input v-model="config.phone" placeholder="请输入联系电话" />
        </div>
        <div class="board-item">
          <input v-model="config.email" placeholder="请输入邮箱" />
        </div>
        <div class="board-item">
          <input v-model="config.address" placeholder="请输入联系地址" />
        </div>
        <div class="board-btn" @click="handleClick">
          发送
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setComment } from '../services'
export default {
  data () {
    return {
      show: false,
      content: '',
      config: {},
      bottom: 0
    }
  },

  created () {
    window.eventBus.$on('boardShow',() => {
      this.show = true
    });

    document.addEventListener('scroll', () => {
      this.show = false
    })

    const width = document.body.getBoundingClientRect().width
    const height = window.screen.height
    if (width > 1280 && width <= 1680) {
      this.bottom = (height - 375) / 2
    } else if (width >= 1920) {
      this.bottom = (height - 500) / 2
    } else {
      this.bottom = (height - 300) / 2
    }
  },

  destroyed () {
    document.removeEventListener('scroll')
  },

  methods: {
    close () {
      this.show = false
    },

    handleClick () {
      setComment({
        org_code: 'aec',
        content: this.content,
        comment_user_info: JSON.stringify(this.config)
      }).then(() => {
        this.show = false
      })
    }
  },

  computed: {
    boardClasses: function () {
      return `${this.show ? 'show' : ''}`
    },

    boardStyle: function () {
      return {
        bottom: this.bottom + 'px'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.board {
  position: fixed;
  width: 250px;
  height: 300px;
  right: -250px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  flex-direction: column;
  transition: right .5s ease-in-out;

  @media (min-width: 1280px) and (max-width: 1680px){
    width: 375px;
    height: 375px;
    right: -375px;
  }
        
  @media screen and (min-width: 1920px){
    width: 500px;
    height: 500px;
    right: -500px;
  }
  &-header {
    background-color: #1899db;
    color: #fff;
    display: flex;
    padding: 8px 10px;
    align-items: center;
    justify-content: space-between;

    &-close {
      background: url('../assets/images/close.png');
      background-size: 100% 100%;
      width: 16px;
      height: 16px;
      cursor: pointer;

      @media (min-width: 1280px) and (max-width: 1680px){
        width: 24px;
        height: 24px;
      }
            
      @media screen and (min-width: 1920px){
        width: 32px;
        height: 32px;
      }
    }
  }

  &-content {
    flex: 1;
    background-color: #ededed;
  }

  &-item {
    margin-left: 10px;
    margin-top: 10px;
    font-size: 9px;

    input, textarea {
      border: none;
      margin: 0px;
      padding: 4px 10px;
      font-size: 9px;

      @media (min-width: 1280px) and (max-width: 1680px){
        font-size: 13px;
      }
            
      @media screen and (min-width: 1920px){
        font-size: 18px;
      }
    }

    textarea {
      width: 200px;
      height: 40px;

      @media (min-width: 1280px) and (max-width: 1680px){
        width: 300px;
        height: 60px;
      }
            
      @media screen and (min-width: 1920px){
        width: 400px;
        height: 80px;
      }
    }

    input {
      width: 200px;

      @media (min-width: 1280px) and (max-width: 1680px){
        width: 300px;
      }
            
      @media screen and (min-width: 1920px){
        width: 400px;
      }
    }
  }

  &-btn {
    width: 64px;
    height: 28px;
    border-radius: 14px;
    background-color: #f45937;
    color: #fff;
    font-size: 9px;
    line-height: 28px;
    text-align: center;
    margin-top: 20px;
    margin-left: 20px;
    cursor: pointer;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 96px;
      height: 42px;
      border-radius: 21px;
      font-size: 14px;
      line-height: 42px;
      margin-top: 30px;
    }
          
    @media screen and (min-width: 1920px){
      width: 128px;
      height: 56px;
      border-radius: 28px;
      font-size: 18px;
      line-height: 56px;
      margin-top: 40px;
    }
  }
}

.mask {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: none;
}


.show {
  .board {
    right: 10px;
  }
  .mask {
    display: block;
  }
}
</style>